import { render, staticRenderFns } from "./Founders.vue?vue&type=template&id=efb1f37c&scoped=true&"
var script = {}
import style0 from "./Founders.vue?vue&type=style&index=0&id=efb1f37c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb1f37c",
  null
  
)

export default component.exports